import { UseSuspenseQueryOptions, useMutation, useQueryClient } from '@tanstack/react-query';

import { Id } from '@feature/utils';
import { Validation } from '@feature/validation';
import { generateValidationApi, generateValidationOptions } from '@feature/validation/validationGenerator';

const validationApi = generateValidationApi('/validation/project');

const { getHistoryOptions, validateOptions, getCurrentOptions } = generateValidationOptions('project', validationApi);

export function getProjectValidationHistoryOptions(projectId: Id): UseSuspenseQueryOptions<Validation[]> {
  return getHistoryOptions(projectId);
}

export function getProjectValidationOptions(projectId: Id): UseSuspenseQueryOptions<Validation | null> {
  return getCurrentOptions(projectId);
}

export function useValidateProject(projectId: Id) {
  const queryClient = useQueryClient();
  return useMutation(validateOptions(projectId, queryClient));
}
